module.exports = __webpack_public_path__ + "img/spotorange.0c1d05fb.svg";